import React from "react";

import Wrapper from "./Wrapper";
import Leaf from "../Leaf";

const Tree = initialProps => {
  const { items, leafDecorator, roots, ...props } = initialProps;

  return (
    <Wrapper>
      {roots.map((item, key) => (
        <Leaf
          {...props}
          leafDecorator={leafDecorator}
          key={key}
          item={item}
          items={items}
          open={props.isOpen(item)}
          selected={props.isSelected(item)}
          childItems={props.childrenSelector(item, items)}
        />
      ))}
    </Wrapper>
  );
};

export default Tree;
